// extracted by mini-css-extract-plugin
export default {"container":"EditScreen_container__dA5ek","image":"EditScreen_image__QX0QC","btn_container":"EditScreen_btn_container__l8IHP","button":"EditScreen_button__xqaJI"};